"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const computePrice_1 = require("../computePrice");
const utils_1 = require("../utils");
/**
 * Remove a reward adjustment out of an order
 * @param event event of type RemoveRewardItemEvent
 * @param prevState previous order state
 */
function default_1(event, prevState = {}) {
    var _a;
    const order = (0, utils_1.clone)(prevState);
    if (!(0, utils_1.isOrderEditable)(order.status)) {
        return order;
    }
    if (event.productId) {
        const orderItems = (_a = order.orderItems) === null || _a === void 0 ? void 0 : _a.filter(item => {
            var _a;
            return item.product.id === event.productId ||
                ((_a = item.variant) === null || _a === void 0 ? void 0 : _a.id) === event.productId;
        });
        orderItems === null || orderItems === void 0 ? void 0 : orderItems.forEach(orderItem => {
            orderItem.adjustments = (orderItem.adjustments || []).filter(adj => adj.id !== event.rewardId);
            orderItem.discountAmount = (0, computePrice_1.computeOrderItemDiscount)(orderItem);
        });
    }
    else {
        order.adjustments = (order.adjustments || []).filter(adj => adj.id !== event.rewardId);
    }
    return {
        ...order,
        ...(0, computePrice_1.computeOrderTotals)(order),
    };
}
exports.default = default_1;
//# sourceMappingURL=removeRewardItem.js.map